import { ArrayParam, StringParam, ObjectParam, JsonParam } from 'use-query-params'

import { dateFormat } from '@app/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'
import { FILTERS_PARAMS_KEYS, MONITORING_STATUS } from '@app/api/constants'

import type { ColumnTitleSchema } from '@app/types/table'
import type { RegistryCurrentListsDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'

export const columnTitleSchema: ColumnTitleSchema<RegistryCurrentListsDataSource> = {
  monitoringKind: 'Вид мониторинга',
  monitoringType: 'Тип мониторинга',
  promotionName: 'Рекламное мероприятие',
  promoDateFrom: 'Дата начала РМ Лента',
  promoDateTo: 'Дата оконч. РМ Лента',
  productCode: 'Код товара',
  store: 'ТК Лента',
  cluster: 'Кластер',
  clustersGroup: 'Группа кластеров',
  salesOrganization: 'Сбытовая организация',
  approvalAt: 'Дата согласования',
  status: 'Статус',
  comment: 'Примечание'
} as const

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringKindIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedMonitoringKindIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedMonitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedStoreIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedClusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clustersGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedClustersGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.promoIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedPromoIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedSalesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.productCodes]: StringParam
} as const

export const tableSearchQuerySchema: TableSearchQuerySchema<RegistryCurrentListsDataSource> = {
  'table-promotionName': StringParam,
  'table-promoDateFrom': ObjectParam,
  'table-promoDateTo': ObjectParam,
  'table-store': StringParam,
  'table-status': JsonParam,
  'table-cluster': StringParam,
  'table-comment': StringParam,
  'table-approvalAt': ObjectParam,
  'table-clustersGroup': StringParam,
  'table-monitoringType': StringParam,
  'table-salesOrganization': StringParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

const options = [
  { label: 'новый', value: MONITORING_STATUS.NEW },
  { label: 'изменен', value: MONITORING_STATUS.CHANGED },
  { label: 'согласован', value: MONITORING_STATUS.APPROVED },
  { label: 'не согласован', value: MONITORING_STATUS.NOT_APPROVED },
  { label: 'изменяется', value: MONITORING_STATUS.RECOMMENDED_CHANGE }
]

export const columnsSearchSchema: ColumnTableSearchSchema<RegistryCurrentListsDataSource> = {
  promotionName: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  promoDateFrom: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  promoDateTo: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  status: { type: columnSearchSchemaOptionType.SELECT, titleWrapperProps, controlProps: { options } },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  comment: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  approvalAt: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  clustersGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  salesOrganization: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps }
}
